export enum WarningEventHybrid {
  /** Hybrid as affects coastal land regions */
  SWELL = 'swell',
}

export enum WarningEventTypeLand {
  RAIN = 'rain',
  WIND = 'wind',
  SNOW = 'snow',
  /** once thunderstorm goes over water it becomes a cyclone or a storm */
  THUNDERSTORM = 'thunderstorm',
  ROAD_SNOW = 'roadsnow',
}

export const WarningEventTypeLandHybrid = {
  ...WarningEventTypeLand,
  ...WarningEventHybrid,
};
export type WarningEventTypeLandHybrid = typeof WarningEventTypeLandHybrid[keyof typeof WarningEventTypeLandHybrid];

export enum WarningEventTypeMarine {
  CYCLONE = 'cyclone', // high seas
  ICE_ACCRETION = 'iceaccretion', // high seas
  SQUALL = 'squall', // marine or high seas
  MARINE_GALE = 'gale', // marine
  MARINE_STORM = 'storm', // marine
  WIND_ADVISORY = 'wind-advisory', // marine
}

export const WarningEventTypeMarineHybrid = {
  ...WarningEventTypeMarine,
  ...WarningEventHybrid,
};
export type WarningEventTypeMarineHybrid =
  typeof WarningEventTypeMarineHybrid[keyof typeof WarningEventTypeMarineHybrid];

// Event types based on MetService BETA
export const WarningEventType = {
  ...WarningEventTypeLand,
  ...WarningEventTypeMarine,
  ...WarningEventHybrid,
};
export type WarningEventType = typeof WarningEventType[keyof typeof WarningEventType];
/**
 * To allow downloaded JSON to be used assigned type by string
 * https://www.designcise.com/web/tutorial/is-it-possible-to-allow-literal-string-values-with-typeScripts-enum-type
 */
